var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.50008 16.5C12.4121 16.5 15.5834 13.1421 15.5834 9C15.5834 4.85786 12.4121 1.5 8.50008 1.5C4.58806 1.5 1.41675 4.85786 1.41675 9C1.41675 13.1421 4.58806 16.5 8.50008 16.5Z",
    fill: "#2AA7E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49427 11.6852C7.3526 11.6852 7.21802 11.6252 7.11885 11.5202L5.11427 9.3977C4.90885 9.1802 4.90885 8.8202 5.11427 8.6027C5.31968 8.3852 5.65968 8.3852 5.8651 8.6027L7.49427 10.3277L11.1351 6.4727C11.3405 6.2552 11.6805 6.2552 11.8859 6.4727C12.0914 6.6902 12.0914 7.05019 11.8859 7.26769L7.86968 11.5202C7.77052 11.6252 7.63593 11.6852 7.49427 11.6852Z",
    fill: "#2AA7E0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.667fbc5e3f4bb9b699d85b1b61fa82c4.svg";
export { ForwardRef as ReactComponent };